import Touchjs from 'touchjs'

const install = Vue => {
  const touches = {
    swipeleft: 1,
    swiperight: 1,
  }
  Vue.directive('touch', {
    inserted(el, binding) {
      let arg = binding.arg
      let modifiers = binding.modifiers || {}
      if (!arg || !touches[arg]) return
      Touchjs.on(el, arg, e => {
        if (modifiers.stop) e.stopPropagation()
        if (modifiers.prevent) e.preventDefault()
        binding.value(e)
      })
    },
  })
}
export default install
